import { contactInfo } from '../mock';

const Footer = () => (
  <footer className="site-footer">
    <div className="footer-inner">
      <div className="footer-copy">
        © {new Date().getFullYear()} Webdream.fr — {contactInfo.name}
      </div>
      <div className="footer-links">
        <a href="/#offers">Offres</a>
        <a href="/#process">Processus</a>
        <a href="/#contact">Contact</a>
        <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
      </div>
    </div>
  </footer>
);

export default Footer;
